import { useState, useCallback, useRef } from 'react';
const HIDDEN = { message: '', visible: false };
const DEFAULT_DURATION = 1500;
export function useStatusOverlay(duration = DEFAULT_DURATION) {
    const [status, setStatus] = useState(HIDDEN);
    const timerRef = useRef(null);
    const show = useCallback((message) => {
        if (timerRef.current)
            clearTimeout(timerRef.current);
        setStatus({ message, visible: true });
        timerRef.current = setTimeout(() => {
            setStatus((prev) => ({ ...prev, visible: false }));
        }, duration);
    }, [duration]);
    return { status, show };
}
